import { Component, OnInit } from '@angular/core';

import { TitleService } from '../../services/utility-services/title.service'


@Component({
  selector: 'my-further-details',
  template: require('./further-details.component.html')
})
export class FurtherDetailsComponent implements OnInit {
  constructor(
    private myTitleService: TitleService
  ) {}
  
  ngOnInit() {
    this.myTitleService.setTitle('Further Details');
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/components/further-details-components/further-details.component.ts
 **/